import {Card, CardTitle, EducationScreen, Gold, RevealBlock, ScreenIntro} from './EducationShell';
import {Glp1ProtocolStatCarousel} from './Glp1ProtocolStatCarousel';
import styles from './Glp1EducationProtocol.module.css';

/** First / shared education screen. Sits BEFORE the variant-specific Intro
 *  screens (branded vs compounded) and frames the whole sequence with a
 *  single premise: sleep apnea is an airway disorder, RISE Expert Care
 *  exists to target the airway directly. */
export const Glp1EducationProtocol = () => (
  <EducationScreen
    ctaLabel="Next"
    analyticsShown="GLP-1 Funnel Education Protocol Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Protocol Continue Tapped"
  >
    <ScreenIntro
      eyebrow={<span className={styles.eyebrow}>A NEW CLINICAL PROTOCOL FOR SLEEP APNEA</span>}
      headline={
        <>
          Most sleep apnea isn&apos;t a sleep disorder. It&apos;s an <Gold>airway</Gold> disorder.
        </>
      }
      subhead="Treating sleep apnea means uncrowding the airway — not managing the symptoms."
    />

    <RevealBlock delayMs={300}>
      <Card className={styles.resultsCard}>
        <CardTitle>
          The results are <Gold>real</Gold>
        </CardTitle>
        <div className={styles.carouselSlot}>
          <Glp1ProtocolStatCarousel />
        </div>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <Card>
        <CardTitle>
          That&apos;s <Gold>why RISE Expert Care exists</Gold>
        </CardTitle>
        <p className={styles.cardBody}>
          Our protocol targets the airway directly — built specifically for sleep apnea.
        </p>
      </Card>
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationProtocol;
